import React from 'react';
import {submit} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';
import Warning from 'components/Warning';

import {MODALS, fetchTeamDetail} from 'ducks/teams';
import {storeDataInModal} from 'ducks/modals';

import {SetInactivityLogoutForm} from './components';

import './styles.css';

class SetInactivityLogoutModal extends React.Component<any> {
  triggerSubmit = () => {
    this.props.submit('setInactivityLogout');
  };

  modalExtraActions = () => {
    return [
      ...this.props.closeModalExtraActions,
      () =>
        fetchTeamDetail({teamId: this.props.data.teamId}, [
          team =>
            storeDataInModal({modalName: MODALS.TEAM_DETAILS, data: {team}})
        ])
    ];
  };

  render() {
    return (
      <Modal
        className="SetInactivityLogoutModal"
        type={Modal.EXTRA_SMALL}
        show={true}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Set Inactivity Logout" />
        <Modal.Body>
          <Warning>
            Your changes will be applied the next time the memmbers from the
            team log in.
          </Warning>
          <SetInactivityLogoutForm
            teamId={this.props.data.teamId}
            modalExtraActions={this.modalExtraActions()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button blue onClick={this.triggerSubmit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  submit
};

export default withModal(
  MODALS.SET_INACTIVITY_LOGOUT,
  mapStateToProps,
  mapDispatchToProps
)(SetInactivityLogoutModal);
